import React, { useEffect } from "react";
import OnboardingScreen from "./OnboardingScreen";
import { redirectLoaded, delay } from "../../utils";
import { EventLogger } from "../../common/utils/EventLogger";

function SevenElevenMain() {
  useEffect(() => {
    const initialize = async () => {
      try {
        await EventLogger.logInfoEvent("7-Eleven main component initializing", {});
        await delay(100);
      } catch (error) {
        console.warn("Error during 7-Eleven main initialization:", error);
      } finally {
        redirectLoaded();
      }
    };
    
    initialize();
  }, []);

  return <OnboardingScreen />;
}

export default SevenElevenMain;